/*jshint esversion: 11 */

import {
    buildInstallmentLabel,
    calculateTotalAmountWithSurcharge,
    parseInstallmentPricing,
} from "./installment-pricing";

function parseAmount(rawValue) {
    const parsed = Number.parseFloat(String(rawValue ?? "0").replace(",", "."));
    return Number.isFinite(parsed) ? parsed : 0;
}

function renderInstallments(root) {
    const amountInput = document.getElementById(root.dataset.amountInputId);
    const select = document.getElementById(root.dataset.selectId);

    if (!amountInput || !select) {
        return;
    }

    const currentValue = select.value || "1";
    const baseAmount = parseAmount(amountInput.value);
    const processingFee = parseAmount(amountInput.dataset.processingFee);
    const maxInstallments = Math.max(1, Number.parseInt(root.dataset.maxInstallments ?? "1", 10) || 1);
    const pricingRules = parseInstallmentPricing(root.dataset.installmentPricing);

    select.innerHTML = "";

    for (let installment = 1; installment <= maxInstallments; installment += 1) {
        const totalAmount = calculateTotalAmountWithSurcharge(baseAmount, pricingRules, installment, processingFee);
        const option = document.createElement("option");
        option.value = String(installment);
        option.textContent = buildInstallmentLabel(totalAmount, installment);
        option.selected = String(installment) === currentValue;
        select.appendChild(option);
    }
}

function mountAsaasInstallments(root) {
    if (root.dataset.initialized === "true") {
        renderInstallments(root);
        return;
    }

    root.dataset.initialized = "true";
    renderInstallments(root);

    const rerender = (event) => {
        const amountInput = document.getElementById(root.dataset.amountInputId);

        if (amountInput && event.detail?.amount) {
            amountInput.value = event.detail.amount;
        }

        if (amountInput && event.detail && "processingFee" in event.detail) {
            amountInput.dataset.processingFee = event.detail.processingFee;
        }

        renderInstallments(root);
    };

    window.addEventListener("updateTotalAmount", rerender);
    window.addEventListener("update-mp-amount", rerender);
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-asaas-installments]").forEach((root) => {
        mountAsaasInstallments(root);
    });
});
